


































































































import {Vue, Component} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
import {PoslovniPartner} from "@/services/BackendProxies";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class KupciIDobavljaci extends mixins(ComponentBaseMixin) {
    columns = [];
    tableOptions = {
        search: true,
        pagination: true,
        onClickRow: row => this.onClickRow(row)
    };
    poslovniPartner = new PoslovniPartner();
    poslovniPartneri = [];

    async created() {
        this.columns = [
            {field: 'pib', width: 200, title: this.$i18n.t('pib')},
            {field: 'naziv', title: this.$i18n.t('naziv')},
            {field: 'mesto', title: this.$i18n.t('mesto')}
        ];
        this.poslovniPartneri = await this.loadData(() => dataProxy.vratiPoslovnePartnere())();
    }

    async sacuvajPoslovnogPartnera() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            await this.saveData(() => dataProxy.sacuvajPoslovnogPartnera(this.poslovniPartner))();
            this.poslovniPartneri = await this.loadData(() => dataProxy.vratiPoslovnePartnere())();
        }
    }

    async obrisiPoslovnogPartnera() {
        const valid = await this.confirmationNeeded('da li zelite da obrisete poslovnog partnera');
        if (valid) {
            this.poslovniPartneri = await this.deleteData(() => dataProxy.obrisiPoslovnogPartnera(this.poslovniPartner.id))();
        }
    }

    novPoslovniPartner() {
        this.poslovniPartner = new PoslovniPartner();
        (<HTMLElement>this.$refs.pib).focus();
    }

    onClickRow(row) {
        this.poslovniPartner = row;
    }

}
